import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';

export default {
  _hasState(field) {
    return !(
      !this.state ||
      !this.state.cueState ||
      !this._getStateField(field)
    );
  },

  _getItemState() {
    return this._getStateField('selectedRow').item;
  },

  _getStateField(field) {
    return this.state.cueState[field];
  },

  _isNoteHidden() {
    const userSettings = this._getStateField('userSettings');
    return userSettings.getIn(['noteColumn', 'hidden']);
  },

  _isDescriptionHidden() {
    return this._getStateField('displayItemDescriptions') !== true;
  },

  _setItemDetailFocus() {
    CuesheetCellActions.selectItemCell(
      this.props.rowIndex,
      EditableCellTypes.ItemTitle,
    );
  },
};
